export const formatTac3pToHtml = (html: string) => {
  html = html
    .replaceAll(/\sstyle.*?>/g, '>')
    .replaceAll(/\sclass.*?>/g, '>')
    .replaceAll('\\n', '');

  return `<div class="root">${html}</div>`;
};
